var names;
(function (names) {
    var bob;
    (function (bob) {
        bob.Application = "bob";
        bob.AppConfiguration = 'AppConfiguration';
    })(bob = names.bob || (names.bob = {}));
})(names || (names = {}));
(function (names) {
    var bob;
    (function (bob) {
        var controllers;
        (function (controllers) {
            controllers.AppController = "AppController";
            controllers.ConfirmModalController = "ConfirmModalController";
            controllers.GalleryController = "GalleryController";
            controllers.NavigationController = "NavigationController";
        })(controllers = bob.controllers || (bob.controllers = {}));
    })(bob = names.bob || (names.bob = {}));
})(names || (names = {}));
(function (names) {
    var bob;
    (function (bob) {
        var services;
        (function (services) {
            services.ArtWorksService = "ArtWorksService";
            services.NotificationService = "NotificationService";
            services.SpinWaitService = "SpinWaitService";
        })(services = bob.services || (bob.services = {}));
    })(bob = names.bob || (names.bob = {}));
})(names || (names = {}));
(function (names) {
    var angular;
    (function (angular) {
        angular.Compile = '$compile';
        angular.Cookies = '$cookies';
        angular.Document = '$document';
        angular.Element = '$element';
        angular.ExceptionHandler = '$exceptionHandler';
        angular.Filter = '$filter';
        angular.Http = '$http';
        angular.HttpParamSerializer = '$httpParamSerializer';
        angular.HttpProvider = '$httpProvider';
        angular.Injector = '$injector';
        angular.Interval = '$interval';
        angular.Locale = '$locale';
        angular.Location = '$location';
        angular.LocationProvider = '$locationProvider';
        angular.Log = '$log';
        angular.Q = '$q';
        angular.RootScope = '$rootScope';
        angular.Route = '$route';
        angular.RouteParams = '$routeParams';
        angular.RouteProvider = '$routeProvider';
        angular.Sce = '$sce';
        angular.Scope = '$scope';
        angular.Timeout = '$timeout';
        angular.Translate = '$translate';
        angular.TranslateProvider = '$translateProvider';
        angular.UiBootstrapModal = '$uibModal';
        angular.UiBootstrapModalInstance = '$uibModalInstance';
        angular.Window = '$window';
    })(angular = names.angular || (names.angular = {}));
})(names || (names = {}));
(function (names) {
    var angular;
    (function (angular) {
        var modules;
        (function (modules) {
            modules.ngAnimate = 'ngAnimate';
            modules.ngCookies = 'ngCookies';
            modules.ngMessages = 'ngMessages';
            modules.ngRoute = 'ngRoute';
            modules.ngTranslate = 'pascalprecht.translate';
            modules.uiBootstrap = 'ui.bootstrap';
            modules.uiGrid = 'ui.grid';
        })(modules = angular.modules || (angular.modules = {}));
    })(angular = names.angular || (names.angular = {}));
})(names || (names = {}));
(function (names) {
    var jquery;
    (function (jquery) {
        jquery.JStorage = 'StorageService.JStorageStatic';
    })(jquery = names.jquery || (names.jquery = {}));
})(names || (names = {}));
(function (names) {
    var misc;
    (function (misc) {
        misc.BlockUI = 'blockUI';
        misc.Toastr = 'toastr';
    })(misc = names.misc || (names.misc = {}));
})(names || (names = {}));

var bob;
(function (bob) {
    var messages;
    (function (messages) {
        messages.ApplicationTitle = "Bobby Ross";
    })(messages = bob.messages || (bob.messages = {}));
})(bob || (bob = {}));

/// <reference path="../../../_references.ts" />
var bob;
(function (bob) {
    var controllers;
    (function (controllers) {
        var ControllerBase = (function () {
            function ControllerBase($scope) {
                this.$scope = $scope;
                this.$scope.controller = this;
            }
            return ControllerBase;
        }());
        controllers.ControllerBase = ControllerBase;
    })(controllers = bob.controllers || (bob.controllers = {}));
})(bob || (bob = {}));

/// <reference path="../../_references.ts" />
var bob;
(function (bob) {
    angular.module(names.bob.Application, [
        names.angular.modules.ngCookies,
        names.angular.modules.ngRoute,
        names.angular.modules.uiBootstrap
    ]).config([names.angular.RouteProvider, function ($routeProvider) { }])
        .factory(names.jquery.JStorage, function () { return angular.element.jStorage; });
})(bob || (bob = {}));

/// <reference path="../../../_references.ts" />
var bob;
(function (bob) {
    var common;
    (function (common) {
        var Utilities = (function () {
            function Utilities() {
            }
            Utilities.smallDevice = function () {
                return angular.element('body').width() < 600 && this.isMobile();
            };
            Utilities.isMobile = function () {
                return (/Android|Kindle|Silk|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent));
            };
            return Utilities;
        }());
        common.Utilities = Utilities;
    })(common = bob.common || (bob.common = {}));
})(bob || (bob = {}));

/// <reference path="../../../_references.ts" />
var bob;
(function (bob) {
    var configuration;
    (function (configuration) {
        angular.module(names.bob.Application)
            .factory(names.bob.AppConfiguration, function () { return appConfiguration; });
    })(configuration = bob.configuration || (bob.configuration = {}));
})(bob || (bob = {}));

/// <reference path="../../../../_references.ts" />
var bob;
(function (bob) {
    var services;
    (function (services) {
        var implementation;
        (function (implementation) {
            var Toastr = 'Toastr';
            var NotificationService = (function () {
                function NotificationService($toastr) {
                    this.$toastr = $toastr;
                }
                NotificationService.prototype.error = function (message, title) {
                    title = this.validateTitle(title);
                    this.$toastr.error(message, title, this.getCommonOptions());
                };
                NotificationService.prototype.info = function (message, title) {
                    title = this.validateTitle(title);
                    this.$toastr.info(message, title, this.getCommonOptions());
                };
                NotificationService.prototype.success = function (message, title) {
                    title = this.validateTitle(title);
                    this.$toastr.success(message, title, this.getCommonOptions());
                };
                NotificationService.prototype.warning = function (message, title) {
                    title = this.validateTitle(title);
                    this.$toastr.warning(message, title, this.getCommonOptions());
                };
                NotificationService.prototype.getCommonOptions = function () {
                    return {
                        closeButton: true
                    };
                };
                NotificationService.prototype.validateTitle = function (title) {
                    if (typeof (title) == 'undefined' || title == null || title.length <= 0) {
                        return bob.messages.ApplicationTitle;
                    }
                    return title;
                };
                return NotificationService;
            }());
            NotificationService.$inject = [Toastr];
            angular.module(names.bob.Application)
                .factory(Toastr, function () { return toastr; })
                .service(names.bob.services.NotificationService, NotificationService);
        })(implementation = services.implementation || (services.implementation = {}));
    })(services = bob.services || (bob.services = {}));
})(bob || (bob = {}));

/// <reference path="../../../../_references.ts" />
var bob;
(function (bob) {
    var services;
    (function (services) {
        var implementation;
        (function (implementation) {
            var ArtWorksService = (function () {
                function ArtWorksService($http, $q, appConfiguration) {
                    this.$http = $http;
                    this.$q = $q;
                    this.appConfiguration = appConfiguration;
                }
                ArtWorksService.prototype.getArtWorks = function (category) {
                    var deferred = this.$q.defer();
                    this.$http.get(this.appConfiguration.webServiceUrl + '/artworks/' + category).then(function (result) {
                        if (result.status == 200) {
                            deferred.resolve(result.data.artWorks);
                            return;
                        }
                        deferred.reject(result);
                    }).catch(function (reason) {
                        deferred.reject(reason);
                    });
                    return deferred.promise;
                };
                return ArtWorksService;
            }());
            ArtWorksService.$inject = [
                names.angular.Http,
                names.angular.Q,
                names.bob.AppConfiguration
            ];
            angular.module(names.bob.Application)
                .service(names.bob.services.ArtWorksService, ArtWorksService);
        })(implementation = services.implementation || (services.implementation = {}));
    })(services = bob.services || (bob.services = {}));
})(bob || (bob = {}));

/// <reference path="../../../../_references.ts" />
var bob;
(function (bob) {
    var services;
    (function (services) {
        var implementation;
        (function (implementation) {
            var BlockUI = 'BlockUI';
            var SpinWaitService = (function () {
                function SpinWaitService() {
                    this.blockList = [];
                }
                SpinWaitService.prototype.block = function (key) {
                    if (typeof (key) != 'undefined' && key != null && key.length > 0) {
                        if (this.blockList.indexOf(key) >= 0) {
                            // We are already blocking for this key.
                            return;
                        }
                    }
                    if (this.blockList.length == 0) {
                        $.blockUI({
                            baseZ: 10000,
                            message: '<div class="br-spinner"></div>'
                        });
                    }
                    this.blockList.push(key);
                };
                SpinWaitService.prototype.unblock = function (key) {
                    if (typeof (key) != 'undefined' && key != null && key.length > 0) {
                        if (this.blockList.indexOf(key) >= 0) {
                            var newBlockList = [];
                            for (var item in this.blockList) {
                                if (this.blockList[item] != key) {
                                    newBlockList.push(this.blockList[item]);
                                }
                            }
                            this.blockList = newBlockList;
                        }
                        else {
                            // Key is not found and we shouldn't unblock in this case.
                            return;
                        }
                    }
                    if (this.blockList.length == 0) {
                        $.unblockUI();
                    }
                };
                return SpinWaitService;
            }());
            angular.module(names.bob.Application)
                .service(names.bob.services.SpinWaitService, SpinWaitService);
        })(implementation = services.implementation || (services.implementation = {}));
    })(services = bob.services || (bob.services = {}));
})(bob || (bob = {}));

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../_references.ts" />
var bob;
(function (bob) {
    var controllers;
    (function (controllers) {
        var GalleryController = (function (_super) {
            __extends(GalleryController, _super);
            function GalleryController($scope, $location, $timeout, $window, artWorksService, notificationService, spinWaitService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$location = $location;
                _this.$timeout = $timeout;
                _this.$window = $window;
                _this.artWorksService = artWorksService;
                _this.notificationService = notificationService;
                _this.spinWaitService = spinWaitService;
                var category = _this.$location.absUrl().indexOf('paintings') >= 0 ? 'painting' : 'drawing';
                _this.initializeGalleryViewModel(category);
                return _this;
            }
            GalleryController.prototype.encodeUri = function (uri) {
                return encodeURIComponent(uri);
            };
            GalleryController.prototype.imageLoaded = function () {
                angular.element('.gallery-image').fadeIn(function () {
                    angular.element('#imageLoading').fadeOut('fast');
                });
            };
            GalleryController.prototype.smallDevice = function () {
                return bob.common.Utilities.isMobile();
            };
            GalleryController.prototype.initializeGalleryViewModel = function (category) {
                var _this = this;
                this.$scope.viewModel = {};
                this.spinWaitService.block('GalleryViewModel');
                this.artWorksService.getArtWorks(category).then(function (result) {
                    _this.$scope.viewModel.artworks = result;
                    _this.setupGalleryCarousel();
                    _this.setCurrentImage(_this.$scope.viewModel.artworks[0].file);
                }).catch(function (reason) {
                    _this.notificationService.error('Art work list unavailable, please call us for support.', bob.messages.ApplicationTitle);
                }).finally(function () {
                    _this.spinWaitService.unblock('GalleryViewModel');
                });
            };
            GalleryController.prototype.setCurrentImage = function (file) {
                var _this = this;
                if (this.$scope.viewModel.currentFileName == file) {
                    return;
                }
                this.$scope.viewModel.currentFileName = file;
                this.$timeout(function () {
                    angular.element('#imageLoading').removeClass('hide');
                }, 500);
                angular.element('#imageLoading').fadeIn('fast', function () {
                    angular.element('.gallery-image').fadeOut('fast', function () {
                        var imageInfo = _this.$scope.viewModel.artworks.filter(function (v) { return v.file == file; })[0];
                        _this.$scope.viewModel.currentImage = imageInfo;
                        if (_this.$scope.$$phase != '$digest') {
                            _this.$scope.$apply();
                        }
                    });
                });
            };
            GalleryController.prototype.setupGalleryCarousel = function () {
                var _this = this;
                var owl = angular.element('.gallery-list');
                owl.css('opacity', 0);
                owl.unbind('initialized.owl.carousel');
                owl.trigger('destroy.owl.carousel');
                owl.on('initialized.owl.carousel', function () {
                    _this.$timeout(function () {
                        owl.css('opacity', 1);
                    }, 250);
                });
                this.$timeout(function () {
                    angular.element(owl).owlCarousel({
                        autoWidth: true,
                        dots: false,
                        lazyLoad: true,
                        loop: true,
                        margin: 10,
                        nav: true,
                        responsive: {
                            0: {
                                items: 2
                            },
                            600: {
                                items: 4
                            },
                            1400: {
                                items: 6
                            }
                        },
                        stagePadding: 20
                    }).on('click', '.owl-item', function (event) {
                        // Note, this is here because ng-click could not be used with the carousel as the items are cloned
                        var targetElement = angular.element(event.target);
                        if (targetElement.hasClass('img-thumbnail')) {
                            var file = targetElement.data('file');
                            _this.setCurrentImage(file);
                        }
                    });
                }, 100);
            };
            return GalleryController;
        }(bob.controllers.ControllerBase));
        GalleryController.$inject = [
            names.angular.Scope,
            names.angular.Location,
            names.angular.Timeout,
            names.angular.Window,
            names.bob.services.ArtWorksService,
            names.bob.services.NotificationService,
            names.bob.services.SpinWaitService
        ];
        controllers.GalleryController = GalleryController;
        angular.module(names.bob.Application)
            .controller(names.bob.controllers.GalleryController, GalleryController)
            .directive('imageonload', function () {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    element.bind('load', function () {
                        //call the function that was passed
                        scope.$apply(attrs.imageonload);
                    });
                }
            };
        });
    })(controllers = bob.controllers || (bob.controllers = {}));
})(bob || (bob = {}));

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../_references.ts" />
var bob;
(function (bob) {
    var controllers;
    (function (controllers) {
        var NavigationController = (function (_super) {
            __extends(NavigationController, _super);
            function NavigationController($scope, $location, $window) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$location = $location;
                _this.$window = $window;
                _this.initializeNavigationController();
                return _this;
            }
            NavigationController.prototype.initializeNavigationController = function () {
            };
            NavigationController.prototype.smallDevice = function () {
                return bob.common.Utilities.isMobile();
            };
            NavigationController.prototype.checkActive = function (path) {
                if (this.$window.location.pathname.indexOf(path) >= 0) {
                    return true;
                }
            };
            NavigationController.prototype.checkHomeActive = function () {
                return !this.checkActive('contact') && !this.checkActive('payment') && !this.checkActive('rentals');
            };
            return NavigationController;
        }(controllers.ControllerBase));
        NavigationController.$inject = [
            names.angular.Scope,
            names.angular.Location,
            names.angular.Window
        ];
        angular.module(names.bob.Application)
            .controller(names.bob.controllers.NavigationController, NavigationController);
    })(controllers = bob.controllers || (bob.controllers = {}));
})(bob || (bob = {}));

/// <reference path="../../../_references.ts" />
var bob;
(function (bob) {
    var viewmodels;
    (function (viewmodels) {
        var ConfirmModalResult;
        (function (ConfirmModalResult) {
            ConfirmModalResult[ConfirmModalResult["Cancel"] = 0] = "Cancel";
            ConfirmModalResult[ConfirmModalResult["Ok"] = 1] = "Ok";
            ConfirmModalResult[ConfirmModalResult["No"] = 2] = "No";
            ConfirmModalResult[ConfirmModalResult["Yes"] = 3] = "Yes";
        })(ConfirmModalResult = viewmodels.ConfirmModalResult || (viewmodels.ConfirmModalResult = {}));
        var ConfirmModalButtonOptions;
        (function (ConfirmModalButtonOptions) {
            ConfirmModalButtonOptions[ConfirmModalButtonOptions["Ok"] = 0] = "Ok";
            ConfirmModalButtonOptions[ConfirmModalButtonOptions["YesNo"] = 1] = "YesNo";
            ConfirmModalButtonOptions[ConfirmModalButtonOptions["YesNoCancel"] = 2] = "YesNoCancel";
        })(ConfirmModalButtonOptions = viewmodels.ConfirmModalButtonOptions || (viewmodels.ConfirmModalButtonOptions = {}));
        var CancelText = 'Cancel';
        var DefaultButtonOption = ConfirmModalButtonOptions.YesNo;
        var NoText = 'No';
        var OkText = 'Ok';
        var YesText = 'Yes';
        var ConfirmModalViewModel = (function () {
            function ConfirmModalViewModel(prompt, title, confirmButtonOption, cancelText, noText, okText, yesText) {
                if (confirmButtonOption === void 0) { confirmButtonOption = DefaultButtonOption; }
                if (cancelText === void 0) { cancelText = CancelText; }
                if (noText === void 0) { noText = NoText; }
                if (okText === void 0) { okText = OkText; }
                if (yesText === void 0) { yesText = YesText; }
                this.cancelText = cancelText;
                this.confirmModalButtonOption = confirmButtonOption;
                this.noText = noText;
                this.okText = okText;
                this.prompt = prompt;
                this.title = title;
                this.yesText = yesText;
            }
            return ConfirmModalViewModel;
        }());
        viewmodels.ConfirmModalViewModel = ConfirmModalViewModel;
    })(viewmodels = bob.viewmodels || (bob.viewmodels = {}));
})(bob || (bob = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var bob;
(function (bob) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = '/staticpages/confirmmodal.html';
        var ConfirmModalController = (function (_super) {
            __extends(ConfirmModalController, _super);
            function ConfirmModalController($scope, $sce, $uibModalInstance, viewModel) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$sce = $sce;
                _this.$uibModalInstance = $uibModalInstance;
                $scope.viewModel = viewModel;
                return _this;
            }
            ConfirmModalController.prototype.buttonOptionOk = function () {
                var viewModel = this.$scope.viewModel;
                return viewModel.confirmModalButtonOption == bob.viewmodels.ConfirmModalButtonOptions.Ok;
            };
            ConfirmModalController.prototype.buttonOptionYesNo = function () {
                var viewModel = this.$scope.viewModel;
                return viewModel.confirmModalButtonOption == bob.viewmodels.ConfirmModalButtonOptions.YesNo;
            };
            ConfirmModalController.prototype.buttonOptionYesNoCancel = function () {
                var viewModel = this.$scope.viewModel;
                return viewModel.confirmModalButtonOption == bob.viewmodels.ConfirmModalButtonOptions.YesNoCancel;
            };
            ConfirmModalController.prototype.cancelConfirm = function () {
                this.$uibModalInstance.close(bob.viewmodels.ConfirmModalResult.Cancel);
            };
            ConfirmModalController.prototype.closeConfirm = function () {
                var confirmReturn = this.buttonOptionOk()
                    ? bob.viewmodels.ConfirmModalResult.Ok
                    : this.buttonOptionYesNo()
                        ? bob.viewmodels.ConfirmModalResult.No
                        : this.buttonOptionYesNoCancel()
                            ? bob.viewmodels.ConfirmModalResult.Cancel : null;
                this.$uibModalInstance.close(confirmReturn);
            };
            ConfirmModalController.prototype.getPromptHtml = function () {
                return this.$sce.trustAsHtml(this.$scope.viewModel.prompt);
            };
            ConfirmModalController.prototype.noConfirm = function () {
                this.$uibModalInstance.close(bob.viewmodels.ConfirmModalResult.No);
            };
            ConfirmModalController.prototype.okConfirm = function () {
                this.$uibModalInstance.close(bob.viewmodels.ConfirmModalResult.Ok);
            };
            ConfirmModalController.prototype.yesConfirm = function () {
                this.$uibModalInstance.close(bob.viewmodels.ConfirmModalResult.Yes);
            };
            ConfirmModalController.showOk = function (prompt, title) {
                var viewModel = new bob.viewmodels.ConfirmModalViewModel(prompt, title, bob.viewmodels.ConfirmModalButtonOptions.Ok);
                return this.showConfirm(viewModel);
            };
            ConfirmModalController.showYesNo = function (prompt, title) {
                var viewModel = new bob.viewmodels.ConfirmModalViewModel(prompt, title);
                return this.showConfirm(viewModel);
            };
            ConfirmModalController.showConfirm = function (viewModel) {
                var $injector = angular.element('html').injector();
                var $uibModal = $injector.get(names.angular.UiBootstrapModal);
                return $uibModal.open({
                    controller: names.bob.controllers.ConfirmModalController,
                    resolve: {
                        viewModel: viewModel
                    },
                    size: 'sm',
                    templateUrl: TemplateUrl
                });
            };
            return ConfirmModalController;
        }(bob.controllers.ControllerBase));
        ConfirmModalController.$inject = [
            names.angular.Scope,
            names.angular.Sce,
            names.angular.UiBootstrapModalInstance,
            'viewModel'
        ];
        controllers.ConfirmModalController = ConfirmModalController;
        angular.module(names.bob.Application)
            .controller(names.bob.controllers.ConfirmModalController, ConfirmModalController);
    })(controllers = bob.controllers || (bob.controllers = {}));
})(bob || (bob = {}));

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../_references.ts" />
var bob;
(function (bob) {
    var AppController = (function (_super) {
        __extends(AppController, _super);
        function AppController($scope, $timeout, $window, notificationService, spinWaitService) {
            var _this = _super.call(this, $scope) || this;
            _this.$scope = $scope;
            _this.$timeout = $timeout;
            _this.$window = $window;
            _this.notificationService = notificationService;
            _this.spinWaitService = spinWaitService;
            _this.initializeApplicationViewModel($scope);
            return _this;
        }
        AppController.prototype.initializeApplicationViewModel = function (scope) {
            scope.viewModel = {};
        };
        AppController.prototype.smallDevice = function () {
            return bob.common.Utilities.isMobile();
        };
        return AppController;
    }(bob.controllers.ControllerBase));
    AppController.$inject = [
        names.angular.Scope,
        names.angular.Timeout,
        names.angular.Window,
        names.bob.services.NotificationService,
        names.bob.services.SpinWaitService
    ];
    angular.module(names.bob.Application)
        .controller(names.bob.controllers.AppController, AppController);
})(bob || (bob = {}));

//# sourceMappingURL=app.js.map
